import React from "react";
import ReactDOM from "react-dom";
import { App } from "./app/components/app";

ReactDOM.render(<App />, document.getElementById("app"));
